// extracted by mini-css-extract-plugin
export var optionGrid = "_af-7";
export var optionList = "_af-6";
export var questionsBlock = "_af-9";
export var spacer = "_af-5";
export var stepCenteredContent = "_af-3";
export var stepInner = "_af-0";
export var stepInnerFullWidth = "_af-1";
export var stepInnerLockScroll = "_af-2";
export var stepTransitionFrame = "_af-4";
export var welcomeBlock = "_af-8";